module.exports = __webpack_public_path__ + "img/CIMB Bank.f35a4366.png";